import React, { Fragment, useContext } from 'react';
import './Styles.css'
import {CustomCtx} from "../../context";

const LogoBranding = (props) => {
    const {custom} = useContext(CustomCtx);
    return <Fragment>
        <img src={custom.logo ? custom.logo : "/images/logos/inclinix-logo.png"} className="logoImg" alt="insta-Consult-logo" />
    </Fragment>
}
export default LogoBranding;